import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import api from "../api/api";

// Auth and allowed pages (add /onboarding for QuickProfileSetup)
const AUTH_PAGES = new Set(["/login", "/register", "/onboarding"]);

const ProtectedRoute = ({ children }) => {
  const rawToken = localStorage.getItem("token");
  const token = rawToken || "";
  const location = useLocation();
  const pathname = location?.pathname || "";

  const [checking, setChecking] = useState(true);
  const [profileComplete, setProfileComplete] = useState(false);

  useEffect(() => {
    // If no token, redirect handled below
    if (!token) {
      setChecking(false);
      return;
    }

    // Don’t check profile on public/auth pages
    if (AUTH_PAGES.has(pathname)) {
      setChecking(false);
      return;
    }

    let cancelled = false;

    async function checkProfile() {
      try {
        const res = await api.get("/profile");
        const profile = res.data || {};

        // ✅ Same fields used in QuickProfileSetup
        const isComplete =
          profile.fullName?.trim() && profile.phone?.trim() && profile.title?.trim();

        if (!cancelled) setProfileComplete(Boolean(isComplete));
      } catch {
        if (!cancelled) setProfileComplete(false);
      } finally {
        if (!cancelled) setChecking(false);
      }
    }

    checkProfile();
    return () => {
      cancelled = true;
    };
  }, [token, pathname]);

  // ✅ 1. If no token → redirect to login
  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // ✅ 2. While checking
  if (checking) {
    return <div className="p-6 text-center">Checking profile...</div>;
  }

  // ✅ 3. If profile incomplete → go to onboarding (QuickProfileSetup)
  if (!profileComplete && pathname !== "/onboarding" && !AUTH_PAGES.has(pathname)) {
    return <Navigate to="/onboarding" replace />;
  }

  // ✅ 4. Otherwise render the page
  return children;
};

export default ProtectedRoute;
